import { api } from '../api';

const getVehicleCostCenter = async ({ customerId, vouId, costCenterId }) => {
  const response = await api({
    url: `VehicleCostCenters/getList`,
    method: 'GET',
    headers: {
      'x-skip-loader': true,
    },
    params: {
      customerId: customerId,
      VouId: vouId,
      CostCenterId: costCenterId,
    },
  });
  return response.data;
};

const createVehicleCostCenter = async ({ request }) => {
  const response = await api({
    url: `VehicleCostCenters/create`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data: request,
  });
  return response.data;
};

const updateVehicleCostCenter = async ({ request }) => {
  const response = await api({
    url: `VehicleCostCenters/update`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data: request,
  });
  return response.data;
};

const deleteVehicleCostCenter = async ({ request }) => {
  const response = await api({
    url: `VehicleCostCenters/delete`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data: request,
  });
  return response.data;
};

const costCenterServices = {
  getVehicleCostCenter,
  createVehicleCostCenter,
  updateVehicleCostCenter,
  deleteVehicleCostCenter,
};

export default costCenterServices;
